<template>
  <SimpleLoadingChartContainer
    :key="chartKey"
    :chart-options="displayChartOptions"
    :loading="displayLoading"
    loading-text="Loading weather data DTN chart data..."
    :elevation="3"
  >
    <template #header>
      <div class="weather-header">
        <span class="weather-data-dtn-chart-title">
          {{ isRelativeWind ? 'Relative Wind (Provider)' : 'Absolute Wind (Provider)' }}
        </span>
      </div>
    </template>
  </SimpleLoadingChartContainer>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import SimpleLoadingChartContainer from "../../../core/SimpleLoadingChartContainer.vue";

export default {
  name: "WeatherDataDTNChart",

  components: {
    SimpleLoadingChartContainer,
  },

  computed: {
    /* GLOBAL MODE */
    ...mapState("windGlobalModule", {
      isRelativeWind: function (state) {
        return state.isRelativeWind;
      },
    }),

    /* CURRENT VESSEL */
    selectedVessel() {
      return this.$store.state.main.selectedVessel;
    },

    vesselName() {
      return this.selectedVessel
        ? this.selectedVessel.vessel
        : null;
    },

    selectedLeg() {
      return this.$store.state.vesselInformation.selectedLeg;
    },

    /* ABSOLUTE WIND */
    ...mapGetters("vesselInformation/weatherDataModule", {
      absoluteWindChartOptions: "chartOptions",
    }),
    ...mapState("vesselInformation/weatherDataModule", {
      absoluteWindLoading: function (state) {
        return state.fetchLoading;
      },
    }),

    /* RELATIVE WIND (PROVIDER) */
    ...mapGetters("weatherRelativeWindDataModule", {
      relativeWindChartOptions: "chartOptions",
      relativeWindLoading: "fetchLoading",
    }),

    displayChartOptions() {
      return this.isRelativeWind
        ? this.relativeWindChartOptions
        : this.absoluteWindChartOptions;
    },

    displayLoading() {
      return this.isRelativeWind
        ? this.relativeWindLoading
        : this.absoluteWindLoading;
    },
    chartKey() {
      return (
        (this.isRelativeWind ? "rel" : "abs") +
    "-" +
    (this.vesselName || "") +
    "-" +
    (this.selectedLeg ? this.selectedLeg.startDate : "")
      );
    },
  },

  watch: {
    /* Toggle */
    isRelativeWind(newVal) {
      if (!newVal) return;
      this.fetchIfNeeded();
    },

    /* Vessel change */
    vesselName(newVal, oldVal) {
      if (newVal !== oldVal && this.isRelativeWind) {
        this.fetchIfNeeded(true); // force refetch
      }
    },

    /* Leg change */
    selectedLeg(newVal, oldVal) {
      if (newVal !== oldVal && this.isRelativeWind) {
        this.fetchIfNeeded(true); // force refetch
      }
    },
  },

  methods: {
    ...mapActions("weatherRelativeWindDataModule", [
      "fetchWeatherRelativeWindData",
    ]),

    fetchIfNeeded(force = false) {
      if (!this.vesselName || !this.selectedLeg) return;

      if (!force) {
        if (
          this.relativeWindChartOptions &&
          this.relativeWindChartOptions.series &&
          this.relativeWindChartOptions.series.length > 0
        ) {
          return; // already loaded
        }
      }

      this.fetchWeatherRelativeWindData();
    },
  },
};
</script>

<style scoped>
.weather-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.weather-data-dtn-chart-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--color-text);
}

.weather-toggle-btn {
  border: 3px solid var(--color-border);
  background: transparent;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  color: rgb(49, 159, 192);
  transition: all 0.2s ease;
}

.weather-toggle-btn:hover {
  background: rgba(0, 0, 0, 0.08);
}
</style>
